import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../../app/store";
import { TBS_API_URL } from "../../config";
import type {
  BankAccount,
  ConfigList,
  NumberTemplate,
  Tax,
  Warehouse,
} from "../../types/tbs/config";

// Tiendas Biai — configuration. **Reads only**: Phase 1 has no config writes, and the endpoints do
// not exist, so there is nothing here to call them with.
//
// One tag for all four. They are edited together or not at all — today, not at all — and separate
// tags would be four cache keys for data that changes a few times a year.

export const tbsConfigApi = createApi({
  reducerPath: "tbsConfigApi",
  tagTypes: ["TbsConfig"],
  baseQuery: fetchBaseQuery({
    baseUrl: TBS_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      const tenantId = (getState() as RootState).tbsTenant.tenantId;
      if (tenantId) headers.set("X-Tenant-Id", tenantId);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTaxes: builder.query<ConfigList<Tax>, void>({
      query: () => "/v1/taxes",
      providesTags: ["TbsConfig"],
    }),
    getWarehouses: builder.query<ConfigList<Warehouse>, void>({
      query: () => "/v1/warehouses",
      providesTags: ["TbsConfig"],
    }),
    getBankAccounts: builder.query<ConfigList<BankAccount>, void>({
      query: () => "/v1/bank-accounts",
      providesTags: ["TbsConfig"],
    }),
    /** Admin only — these carry the DIAN resolutions. A cashier's token gets 403. */
    getNumberTemplates: builder.query<ConfigList<NumberTemplate>, void>({
      query: () => "/v1/number-templates",
      providesTags: ["TbsConfig"],
    }),
  }),
});

export const {
  useGetTaxesQuery,
  useGetWarehousesQuery,
  useGetBankAccountsQuery,
  useGetNumberTemplatesQuery,
} = tbsConfigApi;
